
const isPCUserDeviceType=(userAgent)=>{
    let Agents=["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
    var flag = true;
    Agents.map((item,index)=>{
        if (userAgent.indexOf(item) > 0) {
            flag = false;
            return ;
        }
    })
    return flag;
}

export {
    isPCUserDeviceType,
};